import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  PayoffScheduleEnum,
  ScheduleType
} from 'src/app/product-capture/model/enums/product-capture.enums';
import { NumberUtils } from 'src/app/product-capture/utils/number.utils';
import { BarrierType } from 'src/app/static-data/models/consts/barrier-types.const';

@Pipe({
  name: 'redemptionAmount',
})
export class RedemptionAmountPipe implements PipeTransform {
  transform(
    values: any[],
    form: UntypedFormGroup,
    editForm: UntypedFormGroup,
    groupName: number,
    type: ScheduleType
  ): string {
    const { amountType, amountStepSize, amount, deferredPeriods } = form.value;

    if (type === ScheduleType.CALLABILITY && groupName + 1 <= deferredPeriods) {
      return 'Deferred';
    }

    if (amountType === BarrierType.STEPPED) {
      let { value } = amount;
      const numberType = value.indexOf('%') > -1 ? '%' : '';

      let period = editForm.get(PayoffScheduleEnum.period).value;
      period = type === ScheduleType.CALLABILITY ? period - deferredPeriods : period;
      
      value =
        this.stripPercentSign(value) +
        (period - 1) * this.stripPercentSign(amountStepSize?.value);

        if (value) {
          return `${NumberUtils.roundAndFormat(`${value}${numberType}`, 2)}${numberType}`;
        }
      }

    return '';
  }

  stripPercentSign(percent: string): number {
    if (percent) {
      return Number(percent.replace(/%/g, ''));
    }
    return null;
  }
}
